import httpClient from '@utils/httpClient.js';

export const getHealthProfiles = (params) => {
  const query = new URLSearchParams();
  if (params.status && params.status !== 'all') query.append('status', params.status);
  if (params.sortBy) query.append('sortBy', params.sortBy);
  if (params.sortDir) query.append('sortDir', params.sortDir);
  if (params.search) query.append('search', params.search);
  query.append('skip', params.skip ?? 0);
  query.append('take', params.take ?? 20);

  return httpClient.get(`api/admin/health/profiles?${query.toString()}`);
};

export const getHealthStats = () => httpClient.get('api/admin/health/stats');

export const getProfileHealthDetail = (profileId) => httpClient.get(`api/admin/health/profile/${profileId}`);

export const reviewProfileHealth = (data) => httpClient.post('api/admin/health/review', data);

export const bulkHealthAction = (data) => httpClient.post('api/admin/health/bulk-action', data);

export const evaluateAllProfiles = () => httpClient.post('api/admin/health/evaluate');

export const evaluateProfile = (profileId) => httpClient.post(`api/admin/health/evaluate/${profileId}`);
